import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { AccountType } from '@/api/enums/supabase';
import { OnboardingRoutes } from '@/config/routes';
import { useOnboardingProgress } from '@/context/OnboardingProgressProvider';
import { getNextOnboardingStep } from '@/utils/onboarding';

export interface RouteState {
  accountType?: AccountType;
  autoSubmit?: boolean;
}

const OnboardingAccountType: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { onboardingProgress } = useOnboardingProgress();

  const urlParams = new URLSearchParams(location.search);
  const campaign = urlParams.get('campaign') || localStorage.getItem('campaign');

  useEffect(() => {
    // Skip account type selection entirely - redirect to next step
    const nextStep = getNextOnboardingStep(
      OnboardingRoutes.accountTypeSelect,
      {
        ...onboardingProgress,
        hasAccountType: true,
        accountType: AccountType.property_manager,
      },
      campaign
    );

    history.replace(...nextStep);
  }, [history, onboardingProgress, campaign]);

  // Return null since we're redirecting immediately
  return null;
};

export default OnboardingAccountType;
